import React, { useEffect } from "react";
import jQuery from "jquery";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";

const borderRadius = require("highcharts-border-radius");
borderRadius(Highcharts);

Highcharts.setOptions({
  plotOptions: {
    series: {
      animation: false,
    },
  },
  lang: {
    thousandsSep: ",",
  },
  credits: false,
});

HighchartsMore(Highcharts);

const ChartType30 = (props) => {
  const { values, titles, colors, prefix, postfix, height } = props;

  const symbol = prefix || "";
  const sign = postfix || "";

  const options = {
    chart: {
      type: "column",
      height: "590px",
      backgroundColor: "transparent",
      style: {
        fontFamily: "Libre Franklin, sans-serif",
      },
    },
    lineWidth: 0,
    title: {
      text: "",
    },

    xAxis: {
      type: "category",
      categories: ["On-Premises Costs", "Diamanti Costs"],
      labels: {
        enabled: false,
        style: {
          fontWeight: 400,
          fontSize: "11px",
        },
      },
    },

    yAxis: {
      title: {
        text: "",
      },
      gridLineColor: "#ffffff",
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
    },

    legend: {
      enabled: false,
    },

    tooltip: {
      distance: -60,

      pointFormat: "<b>" + symbol + "{point.y:,.0f}</b>",
    },
    plotOptions: {
      series: {
        pointWidth: window.innerWidth > 360 ? 131 : 100,
        borderRadiusTopLeft: "16px",
        borderRadiusTopRight: "16px",
        align: "center",
        groupPadding: 1,
        colors: ["#A2D935", "#df6c5a"],
        borderWidth: 0,
        useHTML: true,
        dataLabels: {
          useHTML: true,
          enabled: true,
          formatter: function () {
            console.log("================");
            console.log(this.color);
            return window.innerWidth > 360
              ? "<div ><div style='color:black;text-align: center;font-weight: 700;font-size: 18px;'>" +
                  symbol +
                  "" +
                  Highcharts.numberFormat(this.y, 0) +
                  "</div> <div style='color:black;font-weight: 400;font-size: 13px;'>" +
                  this.x +
                  "</div></div>"
              : "<div ><div style='color:black;text-align: center;font-weight: 700;font-size: 12px;'>" +
                  symbol +
                  "" +
                  Highcharts.numberFormat(this.y, 0) +
                  "</div> <div style='color:black;font-weight: 400;font-size: 10px;'>" +
                  this.x +
                  "</div></div>";
          },
          style: {
            fontSize: "18px",
            fontWeight: 700,
          },
        },
      },
    },
    series: [
      {
        data: [
          {
            name: "Win more deals",
            y: values[0],
            color: "#A2D935",
          },
          {
            name: "Prevent slipped deals",
            y: values[1],
            color: "#02A4D5",
          },
        ],

        pointPadding: 0,
        lineWidth: 0,
      },
    ],
  };

  if (props.debug_mood) {
    console.log("high chart debug mood", options);
  }
  console.log("innerWidth", window.innerWidth);

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
export default ChartType30;
